import React from 'react';
import { Link } from 'react-router-dom';
import { assets } from '../constants/theme';

export default function Footer() {
  const s = {
    footer: {
      backgroundColor: '#0F0703',
      color: '#FAF7F2',
      padding: '5rem 6% 2.5rem',
    },
    inner: {
      maxWidth: '1240px', margin: '0 auto',
    },
    top: {
      display: 'grid',
      gridTemplateColumns: '1.5fr 1fr 1fr 1fr',
      gap: '3rem',
      paddingBottom: '3.5rem',
      borderBottom: '1px solid rgba(250,247,242,0.08)',
      marginBottom: '2.5rem',
    },
    brand: { display: 'flex', flexDirection: 'column', gap: '1.25rem' },
    logoWrapper: {
      display: 'flex', alignItems: 'center',
      gap: '0.75rem', textDecoration: 'none',
    },
    logoImg: { height: '42px', width: 'auto', borderRadius: '50%' },
    logoText: {
      fontFamily: "'Cormorant Garamond', Georgia, serif",
      fontSize: '1.8rem', color: '#FAF7F2',
    },
    tagline: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.88rem', color: 'rgba(250,247,242,0.55)',
      lineHeight: 1.7, maxWidth: '280px',
    },
    socialRow: { display: 'flex', gap: '1rem', marginTop: '0.5rem' },
    social: {
      width: '36px', height: '36px', borderRadius: '50%',
      border: '1px solid rgba(250,247,242,0.15)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: '0.85rem', color: 'rgba(250,247,242,0.6)',
      cursor: 'pointer', transition: 'all 0.3s ease',
      textDecoration: 'none',
    },
    colTitle: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.72rem', fontWeight: 700,
      letterSpacing: '0.15em', textTransform: 'uppercase',
      color: '#D96D29', marginBottom: '1.25rem',
    },
    links: {
      listStyle: 'none', display: 'flex',
      flexDirection: 'column', gap: '0.65rem',
    },
    link: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.88rem', color: 'rgba(250,247,242,0.6)',
      textDecoration: 'none', transition: 'color 0.25s ease',
    },
    bottom: {
      display: 'flex', alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap', gap: '1rem',
    },
    copyright: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.75rem',
      color: 'rgba(250,247,242,0.3)',
      letterSpacing: '0.04em',
    },
    legalLinks: { display: 'flex', gap: '2rem' },
    legalLink: {
      fontFamily: "'Inter', system-ui, sans-serif",
      fontSize: '0.75rem',
      color: 'rgba(250,247,242,0.35)',
      textDecoration: 'none',
      transition: 'color 0.25s ease',
    },
  };

  const linkHover = (e) => e.target.style.color = '#D96D29';
  const linkLeave = (e) => e.target.style.color = 'rgba(250,247,242,0.6)';

  return (
    <footer style={s.footer}>
      <div style={s.inner}>
        <div style={{ ...s.top, gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))' }}>
          {/* Brand Column */}
          <div style={s.brand}>
            <Link to="/" style={s.logoWrapper}>
              <img src={assets.logo} alt="Savana Sips" style={s.logoImg}
                onError={(e) => e.target.style.display = 'none'} />
              <div style={s.logoText}>
                Savana <span style={{ color: '#D96D29' }}>Sips</span>
              </div>
            </Link>
            <p style={s.tagline}>
              "Your Cup! Your Day!" — African specialty coffee that empowers
              communities and elevates your daily ritual.
            </p>
            <div style={s.socialRow}>
              {['𝕏', 'f', 'in', '▶'].map((icon, i) => (
                <a key={i} href="#" style={s.social}
                  onMouseEnter={e => { e.currentTarget.style.borderColor = '#D96D29'; e.currentTarget.style.color = '#D96D29'; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = 'rgba(250,247,242,0.15)'; e.currentTarget.style.color = 'rgba(250,247,242,0.6)'; }}
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Explore */}
          <div>
            <div style={s.colTitle}>Explore</div>
            <ul style={s.links}>
              {[
                { label: 'Coffee Types', to: '/coffee-types' },
                { label: 'Our Process', to: '/process' },
                { label: 'Shop Products', to: '/products' },
                { label: 'Our Vision', to: '/vision' },
              ].map(l => (
                <li key={l.label}>
                  <Link to={l.to} style={s.link} onMouseEnter={linkHover} onMouseLeave={linkLeave}>
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <div style={s.colTitle}>Company</div>
            <ul style={s.links}>
              {[
                { label: 'About Us', href: '/#about' },
                { label: 'Our Mission', href: '/#mission' },
                { label: 'Wholesale', href: '/#wholesale' },
                { label: 'Contact Us', to: '/contact' },
              ].map(l => (
                <li key={l.label}>
                  {l.to ? (
                    <Link to={l.to} style={s.link} onMouseEnter={linkHover} onMouseLeave={linkLeave}>
                      {l.label}
                    </Link>
                  ) : (
                    <a href={l.href} style={s.link} onMouseEnter={linkHover} onMouseLeave={linkLeave}>
                      {l.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <div style={s.colTitle}>Connect</div>
            <ul style={s.links}>
              <li>
                <span style={{ ...s.link, cursor: 'default' }}>
                  📧 Info@savanasips.net
                </span>
              </li>
              <li>
                <span style={{ ...s.link, cursor: 'default' }}>
                  📍 Nairobi, Kenya
                </span>
              </li>
              <li>
                <Link to="/products" style={{ ...s.link, color: '#D96D29', fontWeight: 600 }}>
                  🛒 Shop on Clover →
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div style={s.bottom}>
          <div style={s.copyright}>
            © {new Date().getFullYear()} Savana Sips. All rights reserved.
            Empowering African Coffee Communities.
          </div>
          <div style={s.legalLinks}>
            {['Privacy Policy', 'Terms of Service'].map(l => (
              <a key={l} href="#" style={s.legalLink}
                onMouseEnter={e => e.target.style.color = 'rgba(250,247,242,0.6)'}
                onMouseLeave={e => e.target.style.color = 'rgba(250,247,242,0.35)'}
              >{l}</a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
